import {
  createCollectionMetadata as publicCreateCollectionMetadata,
  getCollectionMetadata as publicGetCollectionMetadata,
  updateCollectionMetadata as publicUpdateCollectionMetadata,
  replaceCollectionMetadata as publicReplaceCollectionMetadata,
  deleteCollectionMetadata as publicDeleteCollectionMetadata,
  listCollectionMetadata as publicListCollectionMetadata,
} from './cloud-autocms-v3-collection-metadata-autocms.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { onCollectionMetadataCreated as publicOnCollectionMetadataCreated } from './cloud-autocms-v3-collection-metadata-autocms.public.js';
import { onCollectionMetadataDeleted as publicOnCollectionMetadataDeleted } from './cloud-autocms-v3-collection-metadata-autocms.public.js';
import { onCollectionMetadataUpdated as publicOnCollectionMetadataUpdated } from './cloud-autocms-v3-collection-metadata-autocms.public.js';

export const createCollectionMetadata: MaybeContext<
  BuildRESTFunction<typeof publicCreateCollectionMetadata> &
    typeof publicCreateCollectionMetadata
> = /*#__PURE__*/ createRESTModule(publicCreateCollectionMetadata);
export const getCollectionMetadata: MaybeContext<
  BuildRESTFunction<typeof publicGetCollectionMetadata> &
    typeof publicGetCollectionMetadata
> = /*#__PURE__*/ createRESTModule(publicGetCollectionMetadata);
export const updateCollectionMetadata: MaybeContext<
  BuildRESTFunction<typeof publicUpdateCollectionMetadata> &
    typeof publicUpdateCollectionMetadata
> = /*#__PURE__*/ createRESTModule(publicUpdateCollectionMetadata);
export const replaceCollectionMetadata: MaybeContext<
  BuildRESTFunction<typeof publicReplaceCollectionMetadata> &
    typeof publicReplaceCollectionMetadata
> = /*#__PURE__*/ createRESTModule(publicReplaceCollectionMetadata);
export const deleteCollectionMetadata: MaybeContext<
  BuildRESTFunction<typeof publicDeleteCollectionMetadata> &
    typeof publicDeleteCollectionMetadata
> = /*#__PURE__*/ createRESTModule(publicDeleteCollectionMetadata);
export const listCollectionMetadata: MaybeContext<
  BuildRESTFunction<typeof publicListCollectionMetadata> &
    typeof publicListCollectionMetadata
> = /*#__PURE__*/ createRESTModule(publicListCollectionMetadata);
/**
 * Triggered when a collection metadata instance is created.
 */
export const onCollectionMetadataCreated: BuildEventDefinition<
  typeof publicOnCollectionMetadataCreated
> &
  typeof publicOnCollectionMetadataCreated = createEventModule(
  publicOnCollectionMetadataCreated
);
/**
 * Triggered when a collection metadata instance is deleted.
 */
export const onCollectionMetadataDeleted: BuildEventDefinition<
  typeof publicOnCollectionMetadataDeleted
> &
  typeof publicOnCollectionMetadataDeleted = createEventModule(
  publicOnCollectionMetadataDeleted
);
/**
 * Triggered when a collection metadata instance is updated.
 */
export const onCollectionMetadataUpdated: BuildEventDefinition<
  typeof publicOnCollectionMetadataUpdated
> &
  typeof publicOnCollectionMetadataUpdated = createEventModule(
  publicOnCollectionMetadataUpdated
);

export {
  PermissionsTemplateType,
  State,
  SiteCreatedContext,
  Namespace,
  DeleteStatus,
  WebhookIdentityType,
} from './cloud-autocms-v3-collection-metadata-autocms.universal.js';
export {
  CollectionMetadata,
  CreateCollectionMetadataRequest,
  CreateCollectionMetadataResponse,
  GetCollectionMetadataRequest,
  GetCollectionMetadataResponse,
  UpdateCollectionMetadataRequest,
  UpdateCollectionMetadataResponse,
  ReplaceCollectionMetadataRequest,
  ReplaceCollectionMetadataResponse,
  DeleteCollectionMetadataRequest,
  DeleteCollectionMetadataResponse,
  ListCollectionMetadataRequest,
  CursorPaging,
  ListCollectionMetadataResponse,
  CursorPagingMetadata,
  Cursors,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  Empty,
  MetaSiteSpecialEvent,
  MetaSiteSpecialEventPayloadOneOf,
  Asset,
  SiteCreated,
  SiteTransferred,
  SiteDeleted,
  DeleteContext,
  SiteUndeleted,
  SitePublished,
  SiteUnpublished,
  SiteMarkedAsTemplate,
  SiteMarkedAsWixSite,
  ServiceProvisioned,
  ServiceRemoved,
  SiteRenamed,
  SiteHardDeleted,
  NamespaceChanged,
  StudioAssigned,
  StudioUnassigned,
  SiteUrlChanged,
  SitePurgedExternally,
  OdeditorAssigned,
  OdeditorUnassigned,
  PicassoAssigned,
  PicassoUnassigned,
  WixelAssigned,
  WixelUnassigned,
  StudioTwoAssigned,
  StudioTwoUnassigned,
  UserDomainMediaEnabled,
  UserDomainMediaDisabled,
  EditorlessAssigned,
  EditorlessUnassigned,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  BaseEventMetadata,
  EventMetadata,
  AccountInfoMetadata,
  CollectionMetadataCreatedEnvelope,
  CollectionMetadataDeletedEnvelope,
  CollectionMetadataUpdatedEnvelope,
  ReplaceCollectionMetadataOptions,
  ListCollectionMetadataOptions,
} from './cloud-autocms-v3-collection-metadata-autocms.universal.js';
export {
  PermissionsTemplateTypeWithLiterals,
  StateWithLiterals,
  SiteCreatedContextWithLiterals,
  NamespaceWithLiterals,
  DeleteStatusWithLiterals,
  WebhookIdentityTypeWithLiterals,
  CreateCollectionMetadataApplicationErrors,
  GetCollectionMetadataApplicationErrors,
  UpdateCollectionMetadataApplicationErrors,
} from './cloud-autocms-v3-collection-metadata-autocms.universal.js';
